import Model from './Model'

export default class DispatchDocket extends Model
{
    getDownloadUrl() {
        return this._links.download
    }

    getFormAttributes() {
        const attributes = this.only(['status_id', 'additional', 'due', 'delivery_address', 'delivery', 'delivery_option', 'items', 'package', 'site_contact','hambro_contact'])
        attributes['package_id'] = this.package
        attributes['hambro_contact_id'] = this.hambro_contact.value
        attributes['site_contact_id'] = this.site_contact.value
        return attributes
    }

    static parseAttributes(attributes = {}) {
        attributes = this.parseDropdownAttributes(attributes, ['package_id']);
        attributes.items = (attributes.items || []).map(item => `${item.id}_${item.quantity}`)

        return attributes
    }

    static async all (filter = 'pending') {
        const config = { params: { filter } }
        const { data } = await Http.get(route('api.v1.dispatch-dockets.index'), config)
        return this.make(data)
    }

    static async allByPackage (packageId, filter = 'pending')
    {
        const config = { params: { filter, package: packageId } }
        const { data } = await Http.get(route('api.v1.dispatch-dockets.index'), config)
        return this.make(data)
    }

    static async create (attributes) {
        attributes.package_id = attributes.package?.value
        attributes.site_contact_id = attributes.site_contact?.value
        attributes.hambro_contact_id = attributes.hambro_contact?.value
        const url = route('api.v1.dispatch-dockets.store')
        const { data } = await Http.post(url, this.parseAttributes(attributes))
        return this.make(data)
    }

    async update (attributes = {}) {
        attributes.package_id = attributes.package?.value
        attributes.site_contact_id = attributes.site_contact?.value
        attributes.hambro_contact_id = attributes.hambro_contact?.value
        const url = route('api.v1.dispatch-dockets.update', this.id)
        const payload = this.constructor.parseAttributes({ ...this.getFormAttributes(), ...attributes })
        const { data } = await Http.put(url, payload)
        return this.fill(data)
    }

    async updateStatus (status_id) {
        const url = route('api.v1.dispatch-dockets.update-status', this.id)
        const { data } = await Http.put(url, {status_id:status_id})
        return this.fill(data)
    }

    async delete () {
        await Http.delete(route('api.v1.dispatch-dockets.destroy', this.id))
    }

    async markAsPending () {
        return this.updateStatus(100);
    }

    async markAsPicked () {
        return this.updateStatus(200);
    }

    async markAsDispatched () {
        return this.updateStatus(300);
    }

    async voidDocket () {
        const url = route('api.v1.dispatch-dockets.void', this.id)
        const { data } = await Http.put(url)
        return this.fill(data)
    }

    async restoreDocket () {
        const url = route('api.v1.dispatch-dockets.restore', this.id)
        const { data } = await Http.put(url)
        return this.fill(data)
    }
    setAttributes(attributes) {
        super.setAttributes(attributes);
        let tokens = attributes.items.map(item => item.name);

        tokens.push(
            attributes.package.label,
            attributes.due,
        )

        this.tokens = tokens.join('|').toLowerCase();
    }
}
